<div class="list-page kapea" style="max-width: 1200px">
  <app-asiakas-otsikko otsikko="Kirjanpidon alustaminen" paluuUrl="/asiakkaat" [asiakas]="asiakas()"></app-asiakas-otsikko>

  <form>
    <mat-radio-group style="display: block; margin-bottom: 2em" [formField]="lomake.kevytVaiTavallinen">
      <mat-radio-button style="margin: 5px" [value]="'kevyt'">Kevyt</mat-radio-button>
      <mat-radio-button style="margin: 5px" [value]="'tavallinen'">Tavallinen</mat-radio-button>
    </mat-radio-group>

    <mat-form-field style="display: block; width: 25em; margin-bottom: 2em">
      <mat-label>Alusta lähtien</mat-label>
      <input type="text" [matDatepicker]="pvmPicker" [formField]="lomake.kirjanpitoAlku" matInput data-lpignore="true" />
      <mat-datepicker-toggle matSuffix [for]="pvmPicker"></mat-datepicker-toggle>
      <mat-datepicker #pvmPicker startView="month"></mat-datepicker>
      @if (onkoVirhe(lomake.kirjanpitoAlku, 'required') && (lomake.kirjanpitoAlku().dirty() || lomake.kirjanpitoAlku().touched())) {
        <mat-error> Valitse päivämäärä </mat-error>
      }
    </mat-form-field>

    @if (!lomake.maksutapa().disabled()) {
      <mat-select placeholder="Alustettava maksutapa" [formField]="lomake.maksutapa" style="display: block; width: 25em; margin-bottom: 2em">
        @for (mt of maksutavatObservable | async; track mt) {
          <mat-option [value]="mt.tunniste">
            {{ mt.nimi }}
          </mat-option>
        }
      </mat-select>
    }
  </form>

  <app-primary-button [disabled]="onkoVirhe(lomake.kirjanpitoAlku, 'required')" (click)="alusta()" actionId="Avasi dialogin: Alusta kirjanpito" [actionContext]="[$any(lomake().value())]" styles="margin: 20px 0;"> Alusta </app-primary-button>
  <div style="font-size: 10px">Huom! Alustaminen voi kestää jopa 10 minuuttia, älä sulje tätä ikkunaa.</div>

  @if (failedMessage()) {
    <div class="lemon-error" style="margin: 20px 0">
      {{ failedMessage() }}
    </div>
  }
</div>
